import Box from '@mui/material/Box';
import React from 'react';

export interface MyReportsListMetaProps {
  /** Reports currently on screen. */
  shown: number;
  /** Reports this user may see, before filtering. */
  total: number;
  hasActiveFilters: boolean;
}

/**
 * The result count above the table, matching the strip the Jobs and Roles lists
 * use.
 *
 * It only reads out while a filter is active — the header badge already carries
 * the unfiltered count, so repeating it here would be noise. The live region
 * stays mounted either way, which is what lets a screen reader announce the
 * count when filtering starts. That announcement is what replaces the removed
 * Search button as the "something happened" signal.
 */
export const MyReportsListMeta: React.FC<MyReportsListMetaProps> = ({
  shown,
  total,
  hasActiveFilters,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      px: '20px',
      py: '3px',
      fontSize: '12px',
      color: 'text.secondary',
      minHeight: '20px',
    }}
  >
    <Box component="span" role="status" aria-live="polite">
      {hasActiveFilters
        ? `Showing ${shown.toLocaleString()} of ${total.toLocaleString()} ${
            total === 1 ? 'report' : 'reports'
          }`
        : ''}
    </Box>
  </Box>
);
